import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../Builders.common.mjs';
import { NopCollector_instance2794m19vxdmgu as NopCollector_instance } from './internal/NopCollector.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function launchIn(_this__u8e3s4, scope) {
  return launch(scope, VOID, VOID, launchIn$slambda(_this__u8e3s4));
}
function *collect(_this__u8e3s4, $completion) {
  return yield* _this__u8e3s4.collect_aksokr_k$(NopCollector_instance, $completion);
}
function launchIn$slambda($this_launchIn) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* /*#__NOINLINE__*/collect($this_launchIn, $completion);
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  launchIn as launchInn279ped9kwez,
};
//endregion

//# sourceMappingURL=Collect.mjs.map
